import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { ValidationDetailBuilder } from '../../models/builders/validation-detail.builder';
import { ValidationBuilder } from '../../models/builders/validation.builder';
import { Validation } from '../../models/validation';
import { ValidationDetail } from '../../models/validation-detail';
import { ValidationDetailSummaryBuilder } from '../../models/builders/validation-detail-summary.builder';
import { ValidationDetailSummary } from '../../models/validation-detail-summary';
import { isArray } from 'util';
import { mapCollection } from '../../utils/collection.utils';

const createRefreshValidationDetailsBody = (validationDetails: ValidationDetailSummary[]) => {
  const productionEvents = (isArray(validationDetails))
    ? mapCollection((validation: ValidationDetailSummary) =>
      ({ hash: validation.hash, program: validation.programHash, print: validation.printHash }), validationDetails)
    : [];

    return { productionEvents };
};

@Injectable()
export class ValidatorApiService {
  private apiUrl: string;

  constructor(private httpClient: HttpClient) {
    this.apiUrl = `${ environment.apiUrl }validations`;
  }

  getValidation (hash: string) {
    return this.httpClient.get(`${this.apiUrl}/${hash}`)
      .pipe(
        map(ValidationBuilder.fromJson)
      );
  }

  getValidations(modelHash?: string) {
    const params = (modelHash) ? new HttpParams().append('model', modelHash) : null;

    return this.httpClient.get(this.apiUrl, { params })
      .pipe(
        map(ValidationBuilder.fromList)
      );
  }

  getValidationDetails(hash: string) {
    return this.httpClient.get(`${this.apiUrl}/${hash}/details`)
      .pipe(
        map(ValidationDetailBuilder.fromList)
      );
  }

  getValidationDetailSummary(hash: string) {
    return this.httpClient.get(`${this.apiUrl}/${hash}/summary`)
      .pipe(
        map(ValidationDetailSummaryBuilder.fromList)
      );
  }

  refreshValidationDetails(hash: string, validationDetails: ValidationDetailSummary[]) {
    return this.httpClient.put<{ completed: boolean }>(`${this.apiUrl}/${hash}/refresh`,
      createRefreshValidationDetailsBody(validationDetails))
      .pipe(
        map(data => data.completed)
      );
  }

  updateValidationDetail(validationDetail: ValidationDetail) {
    const body: any = { program: validationDetail.programHash, print: validationDetail.printHash };
    if (validationDetail.editable) {
      body.realTime = validationDetail.realTime;
    }

    return this.httpClient.put(`${this.apiUrl}/detail/${validationDetail.hash}`, body);
  }

  validate(validation: Validation) {
    return this.httpClient.put(`${ this.apiUrl }/${ validation.hash }/validate`, null);
  }

  deleteAlarm(alarm: ValidationDetail) {
    return this.httpClient.delete(`${ this.apiUrl }/alarm/${ alarm.hash }`);
  }

  moveAlarmToExecution(alarm: ValidationDetail) {
    return this.httpClient.put(`${ this.apiUrl }/alarm/${ alarm.hash }/execution`, {});
  }

  moveAlarmToStop(alarm: ValidationDetail) {
    return this.httpClient.put(`${ this.apiUrl }/alarm/${ alarm.hash }/stop`, {});
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/services/api/validator-api.service.ts